$(function () {
  if (!customElements.get('scenario-rv-swiper')) {
    customElements.define(
      'scenario-rv-swiper',
      class HomeSwiper extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.init();
        }
        animateText($elements) {
          $elements.each(function (index) {
            const $this = $(this);
            setTimeout(function () {
              $this.css({
                opacity: 1,
                transform: 'translateY(0) translateZ(0)',
                transition: 'opacity .6s linear .3s,transform .6s cubic-bezier(.215,.61,.355,1) .3s',
              });
            }, index * 100);
          });
        }
        init() {
          const self = this;
          const root = $(this);
          const $slides = root.find('.swiper-slide');
          if ($slides.length === 0) return;
          if ($slides.length > 1) {
            const initSwiper = () => {
              const swiperEle = root.find('.scenario-rv-swiper')[0];
              const $pagination = root.find('.swiper-pagination');
              new Swiper(swiperEle, {
                loop: true,
                effect: 'fade',
                speed: 600,
                fadeEffect: {
                  crossFade: true,
                },
                autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
                pagination: {
                  el: '.swiper-pagination',
                  clickable: false,
                  type: 'bullets',
                },
                preloadImages: false,
                // 测试仓库改名提交
                lazy: {
                  loadPrevNext: true,
                  loadPrevNextAmount: 1,
                  loadOnTransitionStart: true,
                },
                on: {
                  init: function () {
                    const $elements = $(this.slides[0]).find('.scenario-rv-swiper__text');
                    self.animateText($elements);
                  },
                  slideChangeTransitionStart: function () {
                    $(this.slides[this.previousIndex]).find('.scenario-rv-swiper__text').css({
                      opacity: 0,
                      transform: 'translateY(-60px)',
                      transition: 'none',
                    });

                    const $elements = $(this.slides[this.activeIndex]).find('.scenario-rv-swiper__text');
                    self.animateText($elements);

                    // 切换头部导航主题
                    const theme = $(this.slides[this.activeIndex]).attr('data-theme');
                    $('#lt-header').attr('data-theme', theme);
                  },
                  autoplayTimeLeft(_s, _time, progress) {
                    requestAnimationFrame(() => {
                      $pagination.css('--progress', `${(1 - progress) * 100}%`);
                    });
                  },
                },
              });
            };
            if ('requestIdleCallback' in window) {
              requestIdleCallback(initSwiper);
            } else {
              setTimeout(initSwiper, 1);
            }
          } else {
            const $elements = $slides.find('.scenario-rv-swiper__text');
            self.animateText($elements);
          }
        }
      }
    );
  }
});
